

export default {
  releaseVersionDoc: 'https://bugly.tds.qq.com/docs/tutorial/others/openapi/#docusaurus_skipToContent_fallback',
};
